import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {amChart_featurePoints} from "./amChart_featurePoints";

declare var ko: any;

export class dev_featurePoints_template extends vnTemplate{

    protected filter: filterSimple_template;
    public pagination: pagination_template;
    public roleFilter: filterDropdown_template;
    public validationsList: validationsList_template;

    public chartFeature: amChart_featurePoints;


    protected getTemplateHtml(): string{

        return `

            <strong class="section-title">Feature Points</strong>
            <div class="dash-chart-feature-points">
                ` + this.chartFeature.getHtmlBuild() + ` 
            </div>
            
            <strong class="section-title">Insert new set of data for the quarter</strong>
            <div style="padding: 10px;">
                <textarea data-bind="textInput: dataToInsert" style="height: 300px; width: 300px;"></textarea>
                
                <button data-bind="event: { click: onClickInsert }" style="margin-top: 10px;" class="btn">insert</button>
            </div>
            `;
    }

    protected initPartial(): void {

        this.chartFeature = new amChart_featurePoints("featurePoints", this.getTemplateViewModel(), this.caller);
        this.chartFeature.setMainClass(['dash-chart','ratio-content']);
    }

    protected getTemplateName(): string{

        return "dev-featurePoints-template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{

        return [""];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {

             points: ko.observableArray([])
            ,dataToInsert: ko.observable("")
            ,onClickInsert: function(data, event){ huit_neuf_this.onClickInsert(); }

        };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest(){

        return {
            dataToInsert: this.getTemplateViewModel().dataToInsert()
        }
    }

    public setPoints(points: Array<{name: string, done: number, inProgress: number, modifier: number }>): void{


        for (let i of points) {
            i.done = i.done + i.modifier;
        }

        this.getTemplateViewModel().points(points);
        this.chartFeature.setData(points);
    }

    public drawCharts(){

        this.chartFeature.drawChart();
    }

    protected onClickInsert(){

        if( this.getTemplateViewModel().dataToInsert() != "" ){

            this.caller.insertData();
        }
        else{

            alert("There is nothing to insert, the operation will be canceled.");
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/dev_featurePoints_template.ts